import "./App.css";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./themes/theme";
import { Provider } from "react-redux";
import store from "./redux/store";
import ErrorBoundary from "./component/ErrorBoundary";
import RebliePages from "./pages";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <div id="app1">
          <CssBaseline />
          <ErrorBoundary>
            <RebliePages />
          </ErrorBoundary>
        </div>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
